import './main.css';
import GithubLogo from '../../github_logo.png';
import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";

const App = ({ setSteps, steps }) => {
  const [SubTitleItems] = useState([
    {ID: 1, TITLE: "SAFAHAT OKUMALARI", },
    {ID: 2, TITLE: "Dîvânu Lugâti't-Türk"}, 
    {ID: 3, TITLE: "Evimizden, Dilimizden Deyimler ve Atasözleri"},
    {ID: 4, TITLE: "Kutadgu Bilig", }, 
    ]);
  const [DisplayedSubTitleItems, setDisplayedSubTitleItems] = useState([]);

  useEffect(() => {
    if (DisplayedSubTitleItems.length < SubTitleItems.length) {
      const timer = setTimeout(() => {
        setDisplayedSubTitleItems((prevDisplayedItems) => [
          ...prevDisplayedItems,
          SubTitleItems[prevDisplayedItems.length],
        ]);
      }, 500); // Delay of 0.5 seconds

      return () => clearTimeout(timer); // Clean up the timeout on component unmount or re-render
    }
  }, [DisplayedSubTitleItems, SubTitleItems]);

  return (
    <div>
      <header className="header">
        <Link to={"/"} className='HeaderLink'>
            <div title="Abidinpaşa Anadolu Lisesi dilimizin zenginlikleri projesi" className="logo">DİLİMİZİN ZENGİNLİKLERİ</div>
        </Link>
      </header>
      <main className='MainHomepage_v2'>
        <h2 className='ProjectsTextColor'>projelerimiz:</h2>
        <ul id="list">
          {DisplayedSubTitleItems.map((item, index) => (
            <li key={index} className="show">
              <Link to={"/project?id=" + item.ID.toString()}  className="list-link">
                {item.TITLE}
              </Link>
            </li>
          ))}
        </ul>
      </main>
      <footer className="footer">
        <a href="https://github.com/amirm-official7/AAL_EDEBIYAT/" target="_blank" className="footer-link">
          <div>
            <img src={GithubLogo} alt="GitHub Logo" className="github-logo" />
            <span>GitHub</span>
          </div>
        </a>
      </footer>
    </div>
  );
}

export default App;
